
import { findAll, find } from "../utils/dom";

const Menu = () =>{

	const $ = {
		menuMobile: find('[js-menu-mobile]'),
		btOpenMobile: find(`[js-menu="open"]`),
		btClosedMobile: find(`[js-menu="closed"]`),

		menuDesktop: findAll(`[js-menu-desktop]`),
		menuDesktopGrau2: findAll(`[js-menu-grau2-desktop]`)
	}


	$.btOpenMobile?.addEventListener("click", (e)=>{
		$.menuMobile?.classList.add("active");
		$.btOpenMobile?.classList.remove("active");
		$.btClosedMobile?.classList.add("active");
	})

	$.btClosedMobile?.addEventListener("click", (e)=>{
		$.menuMobile?.classList.remove("active")
		$.btClosedMobile?.classList.remove("active");
		$.btOpenMobile?.classList.add("active");
	})



	function desativeAllMenu(){
		const subMenus = findAll(`[js-sub-menu-desktop].active`);
		subMenus?.forEach((item)=>{
			item.classList.remove("active");
			item.classList.add("invisible");
		})

		const itens = findAll('[js-sub-menu-grau2-desktop].active');
		itens?.forEach((item)=>{
			item.classList.remove("active");
			item.classList.add("hidden");
		})


		const subMenuGrau2 = findAll('[js-content-sub-menu-grau2]');
		subMenuGrau2?.forEach((item)=>{
			item.classList.add("invisible")
		})
	}



	function removeAllActiveSubmenu(){
		const subMenus = findAll(`[js-sub-menu-desktop].active`);
		subMenus?.forEach((item)=>{
			item.classList.remove("active");
			item.classList.add("invisible");
		})
	}
	
	$.menuDesktop?.forEach((item)=>{

		/** Evento hover */
		item?.addEventListener("mouseover", (e)=>{
			const idMenu = e.target.getAttribute('js-menu-desktop');
			
			const subMenu = find(`[js-sub-menu-desktop='${idMenu}']`);
			if(subMenu){
				removeAllActiveSubmenu()
				subMenu.classList.add("active");
				subMenu.classList.remove('invisible');


				subMenu.addEventListener("mouseleave", ()=>{
					desativeAllMenu()
				})
			}
		})
	})


	function removeAllItemSubMenu(){
		const itens = findAll('[js-sub-menu-grau2-desktop].active');
		itens?.forEach((item)=>{
			item.classList.remove("active");
			item.classList.add("hidden");
		})
	}

	$.menuDesktopGrau2?.forEach((item)=>{
		item?.addEventListener("mouseover", (e)=>{
			removeAllItemSubMenu();
			const idMenu = e.target.getAttribute('js-menu-grau2-desktop');

			const subItemMenu = findAll(`[js-sub-menu-grau2-desktop='${idMenu}']`);
			if(!subItemMenu) return;


			
			const parent = e.target.parentNode.parentNode.parentNode;
			const resultParent = parent.querySelector('[js-content-sub-menu-grau2]');
			if(subItemMenu.length > 0){
				resultParent?.classList.remove("invisible");
			}else{
				resultParent?.classList.add("invisible");
			}
			

			subItemMenu?.forEach((item)=>{
				item.classList.add("active");
				item.classList.remove("hidden");
			})
		})
	})
	

	
}

export default Menu;